// extracted by mini-css-extract-plugin
export default {"overlay":"Gu-z","bodyOpen":"Hu-z","content":"Iu-z","header":"Ju-z","close":"Ku-z","closeNoHeading":"Lu-z"};